export function pFilerreader(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = resolve; // CHANGE to whatever function you want which would eventually call resolve
        reader.readAsArrayBuffer(file);
    });
}



// WEBPACK FOOTER //
// ./src/helpers/excel_helpers.js